'use client'

import React from 'react'

import { ButtonV2, ButtonV2Props, useAGGWrapperContext } from '@fsg/gui-bits'

type Props = {
  fileName?: string
  activeView?: string
} & ButtonV2Props

export function ExportCSV({ fileName, activeView = 'all', ...buttonProps }: Props) {
  const { gridRef, allGridManager, myGridManager } = useAGGWrapperContext()
  const [loading, setLoading] = React.useState<boolean>(false)

  async function handleExportCSVClick() {
    if (!gridRef.current.api) throw new Error('Grid API is not ready')

    setLoading(true)

    if (allGridManager || myGridManager) {
      if (activeView === 'all') {
        await allGridManager.exportAllData(gridRef, fileName)
      } else {
        await myGridManager.exportAllData(gridRef, fileName)
      }
    } else {
      let currentDate = new Date().toJSON().slice(0, 10)
      const csvTitle = `Engage - ${currentDate}`
      gridRef.current.api.exportDataAsCsv({
        fileName: fileName ?? csvTitle,
        allColumns: true,
      })
    }

    setLoading(false)
  }

  return (
    <ButtonV2 loading={loading} className="font-bold hidden md:block" variant="secondary" size="md" type="button" onClick={handleExportCSVClick} {...buttonProps}>
      Export
    </ButtonV2>
  )
}
